import React from 'react';
import './style.scss';

interface Props {
    pay: number | React.ReactElement;
    status: string;
    background: 1 | 3;
    className?: string;
}

const Payment:React.FC<Props> = (props) => {
  const {
    pay, status, background, className = '',
  } = props;
  const renderBackground = () => {
    switch (background) {
      case 1:
        return 'bg-card-payment-1';
      case 3:
        return 'bg-card-payment-3';
      default:
        return 'bg-card-payment-1';
    }
  };
  return (
    <div className={`card-payment-container ${renderBackground()} ${className}`}>
      <div className="fz-20 fw-bold">
        {typeof pay === 'number' ? (
          `$${pay.toLocaleString()}`
        ) : (
          pay
        )}
      </div>
      <div className="fz-14">{status}</div>
    </div>
  );
};

export default Payment;
